import { useContext } from 'react';

import SettingsContext from './SettingsContext';

const useSettingsContext = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettingsContext must be a child of MainProvider');
  }
  return { ...useContext(SettingsContext) };
};
export default useSettingsContext;
